var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cenario-loading"},[_c('LoadingPadraoContainer',{attrs:{"fraseLoading":['Criando Cenário', 'Aguarde um momento'],"delay":"5000","classe":"azul"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }